import { useContext } from 'react';

import { PageInfoHeader } from 'components/PageInfoHeader/PageInfoHeader';
import { SiteFinanceFilterContext } from 'components/pages/finance/SiteFinance/SiteFinanceContext';

import Button from '../../../../../common/general/Button';
import ButtonGroup from '../../../../../common/general/ButtonGroup';

import { SiteFinanceFilters } from './SiteFinanceFilters/SiteFinanceFilters';

export const SiteFinanceHeader = () => {
  const { exportSiteFinanceReport, isSiteFinanceExportButtonDisabled } = useContext(SiteFinanceFilterContext);
  return (
    <PageInfoHeader
      className="site-finance-page-header"
      right={
        <ButtonGroup>
          <Button
            className="site-finance-export-button"
            size="h28"
            priority="medium"
            onClick={exportSiteFinanceReport}
            disabled={isSiteFinanceExportButtonDisabled()}
          >
            Export
          </Button>
        </ButtonGroup>
      }
    >
      <SiteFinanceFilters />
    </PageInfoHeader>
  );
};
